export enum EventNames {
	PAGE_URL_CHANGE = "PAGE_URL_CHANGE",
	TOP_NAV__MY_PLANNER = "TOP_NAV__MY_PLANNER",
	TOP_NAV__THEME_CHANGER = "TOP_NAV__THEME_CHANGER",
	TOP_NAV__MY_PATIENTS = "TOP_NAV__MY_PATIENTS",
	TOP_NAV__RCA = "TOP_NAV__RCA",
	TOP_NAV__CONSULTATIONS = "TOP_NAV__CONSULTATIONS",
	TOP_NAV__CHALLENGES = "TOP_NAV__CHALLENGES",
	TOP_NAV__ODIN = "TOP_NAV__ODIN",
	TOP_NAV__NOTIFICATIONS_OPEN = "TOP_NAV__NOTIFICATIONS_OPEN",
	TOP_NAV__NOTIFICATIONS_CLOSE = "TOP_NAV__NOTIFICATIONS_CLOSE",
	TOP_NAV__CHAT = "TOP_NAV__CHAT",
	TOP_NAV__GROUPS_ONLY_CHAT = "TOP_NAV__GROUPS_ONLY_CHAT",
	TOP_NAV__PROFILE_DROPDOWN = "TOP_NAV__PROFILE_DROPDOWN",
	TOP_NAV__PROFILE_DROPDOWN__PROFILE = "TOP_NAV__PROFILE_DROPDOWN__PROFILE",
	TOP_NAV__PROFILE_DROPDOWN__WORKING_HOURS = "TOP_NAV__PROFILE_DROPDOWN__WORKING_HOURS",
	TOP_NAV__PROFILE_DROPDOWN__LINKS_LIBRARY = "TOP_NAV__PROFILE_DROPDOWN__LINKS_LIBRARY",
	TOP_NAV__PROFILE_DROPDOWN__REQUESTS = "TOP_NAV__PROFILE_DROPDOWN__REQUESTS",
	TOP_NAV__PROFILE_DROPDOWN__SWITCH_PROFILE = "TOP_NAV__PROFILE_DROPDOWN__SWITCH_PROFILE",
	TOP_NAV__PROFILE_DROPDOWN__MY_MEAL_PLANS = "TOP_NAV__PROFILE_DROPDOWN__MY_MEAL_PLANS",
	TOP_NAV__PROFILE_DROPDOWN__MY_TASKS = "TOP_NAV__PROFILE_DROPDOWN__MY_TASKS",
	TOP_NAV__PROFILE_DROPDOWN__POLLS = "TOP_NAV__PROFILE_DROPDOWN__POLLS",
	TOP_NAV__PROFILE_DROPDOWN__MEDICINE_CATALOG = "TOP_NAV__PROFILE_DROPDOWN__MEDICINE_CATALOG",
	TOP_NAV__PROFILE_DROPDOWN__LOGOUT = "TOP_NAV__PROFILE_DROPDOWN__LOGOUT",
	CALENDER__CALENDAR_TASKS__OTHER_PENDING_TASKS_OPEN = "CALENDER__CALENDAR_TASKS__OTHER_PENDING_TASKS_OPEN",
	CALENDER__CALENDAR_TASKS__OTHER_PENDING_TASKS_CLOSE = "CALENDER__CALENDAR_TASKS__OTHER_PENDING_TASKS_CLOSE",
	CALENDER__CALENDAR_TASKS__OTHER_PENDING_TASKS = "CALENDER__CALENDAR_TASKS__OTHER_PENDING_TASKS",
	CALENDER__CALENDAR_TASKS__TASK_ROW = "CALENDER__CALENDAR_TASKS__TASK_ROW",
	CALENDER__CALENDAR_TASKS__OPEN_USER_PROFILE = "CALENDER__CALENDAR_TASKS__OPEN_USER_PROFILE",
	CALENDER__CALENDAR_TASKS__SLOTTED_TASKS = "CALENDER__CALENDAR_TASKS__SLOTTED_TASKS",
	CALENDER__DATE_SELECTOR__PREVIOUS_DATE = "CALENDER__DATE_SELECTOR__PREVIOUS_DATE",
	CALENDER__DATE_SELECTOR__NEXT_DATE = "CALENDER__DATE_SELECTOR__NEXT_DATE",
	CALENDER__CONSULTATION_CARD__CLICK = "CALENDER__CONSULTATION_CARD__CLICK",
	CALENDER__CONSULTATION_CARD__JOIN = "CALENDER__CONSULTATION_CARD__JOIN",
	PATIENT_CONSULTATIONS__CONSULTATION_CARD__JOIN = "PATIENT_CONSULTATIONS__CONSULTATION_CARD__JOIN",
	PATIENT_CONSULTATIONS__CONSULTATION_DETAILS__JOIN = "PATIENT_CONSULTATIONS__CONSULTATION_DETAILS__JOIN",
	COACH_CONSULTATIONS__FILTER_ONGOING__JOIN_THROUGH_ROW_CLICK = "COACH_CONSULTATIONS__FILTER_ONGOING__JOIN_THROUGH_ROW_CLICK",
	NOTIFICATIONS__NOTIFICATION_INCOMING_CALL_ITEM__CLICK = "NOTIFICATIONS__NOTIFICATION_INCOMING_CALL_ITEM__CLICK",
	NOTIFICATIONS__NOTIFICATION_DOCTOR_COACH_CONNECT_ITEM__CLICK = "NOTIFICATIONS__NOTIFICATION_DOCTOR_COACH_CONNECT_ITEM__CLICK",
	NOTIFICATIONS__NOTIFICATION_PSYCHOLOGIST_COACH_CONNECT_ITEM__CLICK = "NOTIFICATIONS__NOTIFICATION_PSYCHOLOGIST_COACH_CONNECT_ITEM__CLICK",
	NOTIFICATIONS__NOTIFICATION_LAB_REPORT_UPLOADED_ITEM__CLICK = "NOTIFICATIONS__NOTIFICATION_LAB_REPORT_UPLOADED_ITEM__CLICK",
	NOTIFICATIONS__NOTIFICATION_PRESCRIPTION_LEFT_IN_DRAFT_ITEM__CLICK = "NOTIFICATIONS__NOTIFICATION_PRESCRIPTION_LEFT_IN_DRAFT_ITEM__CLICK",
	PATIENT_LIST__FILTER = "PATIENT_LIST__FILTER", //for this the filter name is added by formatting it to the same pattern
	PATIENT_LIST__SEARCH = "PATIENT_LIST__SEARCH",
	PATIENT_LIST__TABLE_FILTER = "PATIENT_LIST__TABLE_FILTER",
	PATIENT_LIST_TABLE_ROW_CLICK = "PATIENT_LIST_TABLE_ROW_CLICK",
	COACH_CONSULTATIONS__FILTER__COMPLETED = "COACH_CONSULTATIONS__FILTER__COMPLETED",
	COACH_CONSULTATIONS__FILTER__UPCOMING = "COACH_CONSULTATIONS__FILTER__UPCOMING",
	COACH_CONSULTATIONS__FILTER__ONGOING = "COACH_CONSULTATIONS__FILTER__ONGOING",
	COACH_CONSULTATIONS_TABLE_ROW_CLICK = "COACH_CONSULTATIONS_TABLE_ROW_CLICK",
	PATIENT_PROFILE__REQUEST_TO_CONNECT_VIA_PERSONAL = "PATIENT_PROFILE__REQUEST_TO_CONNECT_VIA_PERSONAL",
	PATIENT_PROFILE__PREFERRED_CALLING_TIME__EDIT = "PATIENT_PROFILE__PREFERRED_CALLING_TIME__EDIT",
	PATIENT_PROFILE__PREFERRED_CALLING_TIME__SUBMIT = "PATIENT_PROFILE__PREFERRED_CALLING_TIME__SUBMIT",
	PATIENT_PROFILE__NOTIFICATION_SETTINGS__CHECKBOX = "PATIENT_PROFILE__NOTIFICATION_SETTINGS__CHECKBOX",
	PATIENT_PROFILE__PATIENT_TASKS_TABS = "PATIENT_PROFILE__PATIENT_TASKS_TABS",
	PATIENT_PROFILE__PATIENT_TASK_MARK_COMPLETE = "PATIENT_PROFILE__PATIENT_TASK_MARK_COMPLETE",
	PATIENT_PROFILE__OPEN_ODIN_TICKETS__ROW_CLICK = "PATIENT_PROFILE__OPEN_ODIN_TICKETS__ROW_CLICK",
	PATIENT_PROFILE__OPEN_APP_TICKETS__ROW_CLICK = "PATIENT_PROFILE__OPEN_APP_TICKETS__ROW_CLICK",
	PATIENT_PROFILE__QUARTERLY_PROGRESS__OPEN_PROGRESS_REPORT = "PATIENT_PROFILE__QUARTERLY_PROGRESS__OPEN_PROGRESS_REPORT",
	PATIENT_PROFILE__STOP_TASK_CREATION = "PATIENT_PROFILE__STOP_TASK_CREATION",
	PATIENT_PROFILE__CALL_PATIENT = "PATIENT_PROFILE__CALL_PATIENT",
	CALL_PATIENT_CALL = "CALL_PATIENT_CALL",
	CALL_PATIENT_CANCEL = "CALL_PATIENT_CANCEL",
	CALL_PATIENT_PATIENT__PATIENT_DATA_REDIRECTION = "CALL_PATIENT_PATIENT__PATIENT_DATA_REDIRECTION",
	PATIENT_PROFILE__CALL_PATIENT__CALL = "PATIENT_PROFILE__CALL_PATIENT__CALL",
	PATIENT_PROFILE__CALL_PATIENT__CANCEL = "PATIENT_PROFILE__CALL_PATIENT__CANCEL",
	PATIENT_PROFILE__CALL_PATIENT__PATIENT_DATA_REDIRECTION = "PATIENT_PROFILE__CALL_PATIENT__PATIENT_DATA_REDIRECTION",
	PATIENT_PROFILE__COACH_ASSIGNMENT_HISTORY = "PATIENT_PROFILE__COACH_ASSIGNMENT_HISTORY",
	PATIENT_PROFILE__DOCTOR_ASSIGNMENT_HISTORY = "PATIENT_PROFILE__DOCTOR_ASSIGNMENT_HISTORY",
	OPERATIONAL_BOOKINGS__AVAILABLE_BOOKINGS = "OPERATIONAL_BOOKINGS__AVAILABLE_BOOKINGS",
	OPERATIONAL_BOOKINGS_MODAL_SUBMIT = "OPERATIONAL_BOOKINGS_MODAL_SUBMIT",
	OPERATIONAL_BOOKINGS_MODAL = "OPERATIONAL_BOOKINGS_MODAL",
	OPERATIONAL_BOOKINGS__SLOT__SELECT = "OPERATIONAL_BOOKINGS__SLOT__SELECT",
	OPERATIONAL_BOOKINGS__SELECT_DATE = "OPERATIONAL_BOOKINGS__SELECT_DATE",
	PATIENT_CONSULTATIONS_FILTER = "PATIENT_CONSULTATIONS_FILTER",
	PATIENT_CONSULTATIONS__CONSULTATION_CARD__VIEW_MORE = "PATIENT_CONSULTATIONS__CONSULTATION_CARD__VIEW_MORE",
	PATIENT_CONSULTATIONS__CONSULTATION_CARD__CLICK = "PATIENT_CONSULTATIONS__CONSULTATION_CARD__CLICK",
	PATIENT_CONSULTATIONS___CONSULTATION_CARD__START_CONSULTATION = "PATIENT_CONSULTATIONS___CONSULTATION_CARD__START_CONSULTATION",
	PATIENT_CONSULTATIONS__CONSULTATION_CARD__VIEW_AUDIO_RECORDING = "PATIENT_CONSULTATIONS__CONSULTATION_CARD__VIEW_AUDIO_RECORDING",
	PATIENT_CONSULTATIONS__CONSULTATION_CARD__REQUEST_AUDIO_RECORDING = "PATIENT_CONSULTATIONS__CONSULTATION_CARD__REQUEST_AUDIO_RECORDING",
	PATIENT_CONSULTATION_DETAILS__DOCTOR_JOINING_LOGS = "PATIENT_CONSULTATION_DETAILS__DOCTOR_JOINING_LOGS",
	PATIENT_CONSULTATION_DETAILS__PATIENT_JOINING_LOGS = "PATIENT_CONSULTATION_DETAILS__PATIENT_JOINING_LOGS",
	PATIENT_CONSULTATION_DETAILS__JOINING_LOGS_MODAL = "PATIENT_CONSULTATION_DETAILS__JOINING_LOGS_MODAL",
	PATIENT_CONSULTATION_DETAILS__VIEW_PLAN_DETAILS__CLICK = "PATIENT_CONSULTATION_DETAILS__VIEW_PLAN_DETAILS__CLICK",
	PATIENT_CONSULTATION_DETAILS__START_CONSULTATION = "PATIENT_CONSULTATION_DETAILS__START_CONSULTATION",
	PATIENT_CONSULTATION_DETAILS__DOCTOR_PRESCRIPTION__EDIT = "PATIENT_CONSULTATION_DETAILS__DOCTOR_PRESCRIPTION__EDIT",
	PATIENT_CONSULTATION_DETAILS__DOCTOR_PRESCRIPTION__PREVIEW = "PATIENT_CONSULTATION_DETAILS__DOCTOR_PRESCRIPTION__PREVIEW",
	PATIENT_CONSULTATION_DETAILS__DOCTOR_PRESCRIPTION__PRINT = "PATIENT_CONSULTATION_DETAILS__DOCTOR_PRESCRIPTION__PRINT",
	PATIENT_CONSULTATION_DETAILS__DOCTOR_PRESCRIPTION__EMAIL = "PATIENT_CONSULTATION_DETAILS__DOCTOR_PRESCRIPTION__EMAIL",
	LIFESTYLE_RECALL__SAVE = "LIFESTYLE_RECALL__SAVE",
	ACTIVE_PLAN__EDIT_ACTIVE_PLAN = "ACTIVE_PLAN__EDIT_ACTIVE_PLAN",
	ACTIVE_PLAN__OPEN_ACTION_ITEMS = "ACTIVE_PLAN__OPEN_ACTION_ITEMS",
	ACTIVE_PLAN__OPEN_ACTION_ITEMS__SUBMIT = "ACTIVE_PLAN__OPEN_ACTION_ITEMS__SUBMIT",
	ADHERENCE__SUMMARY_TABS = "ADHERENCE__SUMMARY_TABS",
	CGM_DATA__CGM_TAB = "CGM_DATA__CGM_TAB",
	CGM_DATA__VIEW_REPORT = "CGM_DATA__VIEW_REPORT",
	CGM_DATA__GENERATE_PDF_REPORT = "CGM_DATA__GENERATE_PDF_REPORT",
	CGM_DATA__REQUEST_CGM_INSTALLATION = "CGM_DATA__REQUEST_CGM_INSTALLATION",
	CGM_DATA__DAILY_GLUCOSE_PROFILES__TEMPLATES = "CGM_DATA__DAILY_GLUCOSE_PROFILES__TEMPLATES",
	CGM_DATA__DAILY_GLUCOSE_PROFILES__TEMPLATES_TABLE_ROW_SELECT = "CGM_DATA__DAILY_GLUCOSE_PROFILES__TEMPLATES_TABLE_ROW_SELECT",
	CGM_DATA__CGM_INSIGHTS__EDIT = "CGM_DATA__CGM_INSIGHTS__EDIT",
	CGM_DATA__CGM_INSIGHTS__CANCEL = "CGM_DATA__CGM_INSIGHTS__CANCEL",
	CGM_DATA__CGM_INSIGHTS__SUBMIT = "CGM_DATA__CGM_INSIGHTS__SUBMIT",
	CGM_DATA__CGM_INSIGHTS = "CGM_DATA__CGM_INSIGHTS",
	CGM_DATA__ACTIVITY_LOGS__TAB = "CGM_DATA__ACTIVITY_LOGS__TAB",
	CGM_DATA__COMPARE_GRAPHS = "CGM_DATA__COMPARE_GRAPHS",
	CGM_DATA__COMPARE_GRAPHS_MODAL = "CGM_DATA__COMPARE_GRAPHS_MODAL",
	CGM_DATA__COMPARE_GRAPHS_MODAL__RESET_DATES = "CGM_DATA__COMPARE_GRAPHS_MODAL__RESET_DATES",
	CGM_DATA__READER_PHOTOS = "CGM_DATA__READER_PHOTOS",
	DAILY_ACTIVITES__DATE_RANGE__CHANGE = "DAILY_ACTIVITES__DATE_RANGE__CHANGE",
	DAILY_ACTIVITES__TAB = "DAILY_ACTIVITES__TAB",
	FITNESS_DATA__TAB = "FITNESS_DATA__TAB",
	FITNESS_DEVICE_DATA__DATE_RANGE_CHANGE = "FITNESS_DEVICE_DATA__DATE_RANGE_CHANGE",
	SUGAR_JOURNAL__TAB = "SUGAR_JOURNAL__TAB",
	SUGAR_JOURNAL__GLUCOMETER_GRAPH__ADD_NEW_ENTRY = "SUGAR_JOURNAL__GLUCOMETER_GRAPH__ADD_NEW_ENTRY",
	SUGAR_JOURNAL__GLUCOMETER_GRAPH_LOGS_MODAL = "SUGAR_JOURNAL__GLUCOMETER_GRAPH_LOGS_MODAL",
	LAB_TEST__TAB = "LAB_TEST__TAB",
	LAB_TEST__REPORT_PDF_CLICK = "LAB_TEST__REPORT_PDF_CLICK",
	VITALS__SUBMIT = "VITALS__SUBMIT",
	VITALS__EDIT = "VITALS__EDIT",
	VITALS__EDIT_CANCEL = "VITALS__EDIT_CANCEL",
	GOALS__ADD_NEW_ENTRY = "GOALS__ADD_NEW_ENTRY",
	DOCUMENTS__DOCUMENT_CARD_CLICK = "DOCUMENTS__DOCUMENT_CARD_CLICK",
	DOCUMENTS__DOCUMENT_DELETE_CONFIRM = "DOCUMENTS__DOCUMENT_DELETE_CONFIRM",
	DOCUMENTS__UPLOAD_DOCUMENT = "DOCUMENTS__UPLOAD_DOCUMENT",
	DOCUMENTS__UPLOAD_DOCUMENT__CATEGORY = "DOCUMENTS__UPLOAD_DOCUMENT__CATEGORY",
	DOCUMENTS__UPLOAD_DOCUMENT__SUB_CATEGORY = "DOCUMENTS__UPLOAD_DOCUMENT__SUB_CATEGORY",
	DOCUMENTS__UPLOAD_DOCUMENT__UPLOAD_FILE = "DOCUMENTS__UPLOAD_DOCUMENT__UPLOAD_FILE",
	DOCUMENTS__UPLOAD_DOCUMENT__SELECT_DATE = "DOCUMENTS__UPLOAD_DOCUMENT__SELECT_DATE",
	PATIENT_NOTES__VIEW_NOTES_TAB = "PATIENT_NOTES__VIEW_NOTES_TAB",
	PATIENT_NOTES__DOCTOR_COACH_CONNECT__ACKNOWLEDGE = "PATIENT_NOTES__DOCTOR_COACH_CONNECT__ACKNOWLEDGE",
	PATIENT_NOTES__DOCTOR_COACH_CONNECT__SEND_MESSAGE = "PATIENT_NOTES__DOCTOR_COACH_CONNECT__SEND_MESSAGE",
	PATIENT_NOTES__DOCTOR_COACH_CONNECT__ATTACHMENTS_CLICK = "PATIENT_NOTES__DOCTOR_COACH_CONNECT__ATTACHMENTS_CLICK",
	PATIENT_NOTES__DOCTOR_COACH_CONNECT__JUMP_TO_PRESCRIPTION = "PATIENT_NOTES__DOCTOR_COACH_CONNECT__JUMP_TO_PRESCRIPTION",
	PATIENT_NOTES__CREATE_NOTES = "PATIENT_NOTES__CREATE_NOTES",
	PATIENT_NOTES__CREATE_NOTES__CANCEL = "PATIENT_NOTES__CREATE_NOTES__CANCEL",
	PATIENT_NOTES__CREATE_NOTES__DOCTOR_COACH_CONNECT__SAVE = "PATIENT_NOTES__CREATE_NOTES__DOCTOR_COACH_CONNECT__SAVE",
	PATIENT_NOTES__CREATE_NOTES__SAVE = "PATIENT_NOTES__CREATE_NOTES__SAVE",
	PATIENT_TRANSFER_NOTES__CREATE_NOTES__SAVE = "PATIENT_TRANSFER_NOTES__CREATE_NOTES__SAVE",

	PATIENT_NOTES__CREATE_NOTES__DOCTOR_COACH_CONNECT__ATTACH_DOCUMENTS = "PATIENT_NOTES__CREATE_NOTES__DOCTOR_COACH_CONNECT__ATTACH_DOCUMENTS",
	COACH_EDIT_CONSULT = "COACH_EDIT_CONSULT",
	COACH_ONGOING_CONSULT = "COACH_ONGOING_CONSULT",
	DOCTOR_ONGOING_CONSULT = "DOCTOR_ONGOING_CONSULT",
	CALL_PATIENT__CALL = "CALL_PATIENT",
	PATIENT_DATA_ACKNOWLEDGE_INSIGHTS = "PATIENT_DATA_ACKNOWLEDGE_INSIGHTS",
	CONSULT_FOOTER = "CONSULT_FOOTER",
	CREATE_PLAN_TAB__PATIENT_GOALS = "CREATE_PLAN_TAB__PATIENT_GOALS",
	CREATE_PLAN_TAB__PATIENT_GOALS_SELECT_COMMONLY_USED = "CREATE_PLAN_TAB__PATIENT_GOALS_SELECT_COMMONLY_USED",
	CREATE_PLAN_TAB__PRODUCT_COMMERCE__PPT_LINK_CLICK = "CREATE_PLAN_TAB__PRODUCT_COMMERCE__PPT_LINK_CLICK",
	CREATE_PLAN_TAB__THINGS_TO_BUY = "CREATE_PLAN_TAB__THINGS_TO_BUY",
	CREATE_PLAN_TAB__DIET_PLAN__AI_RECOMMENDATION = "CREATE_PLAN_TAB__DIET_PLAN__AI_RECOMMENDATION",
	CREATE_PLAN_TAB__DIET_PLAN__TRIGGER_PDF = "CREATE_PLAN_TAB__DIET_PLAN__TRIGGER_PDF",
	CREATE_PLAN_TAB__DIET_PLAN__EDIT_PLAN = "CREATE_PLAN_TAB__DIET_PLAN__EDIT_PLAN",
	CREATE_PLAN_TAB__DIET_PLAN__DELETE_PLAN = "CREATE_PLAN_TAB__DIET_PLAN__DELETE_PLAN",
	CREATE_PLAN_TAB__DIET_PLAN__SELECT_TEMPLATE = "CREATE_PLAN_TAB__DIET_PLAN__SELECT_TEMPLATE",
	CREATE_PLAN_TAB__DIET_PLAN__CREATE_NEW_PLAN = "CREATE_PLAN_TAB__DIET_PLAN__CREATE_NEW_PLAN",
	CREATE_PLAN_TAB__DIET_PLAN_SELECT_TEMPLATE__ROW_SELECT = "CREATE_PLAN_TAB__DIET_PLAN_SELECT_TEMPLATE__ROW_SELECT",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__SLOT_TAB = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__SLOT_TAB",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__DELETE_SLOT = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__DELETE_SLOT",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__DELETE_SLOT_DOUBLE_CONFIRM = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__DELETE_SLOT_DOUBLE_CONFIRM",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__BLD_VALIDATION = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__BLD_VALIDATION",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__INCLUSION_EXCLUSION_LIST = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__INCLUSION_EXCLUSION_LIST",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__ADD_NEW_SLOT = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__ADD_NEW_SLOT",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__SLOT_TIME_CHANGE = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__SLOT_TIME_CHANGE",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__DISCARD_PLAN = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__DISCARD_PLAN",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__SAVE_AS_DRAFT = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__SAVE_AS_DRAFT",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__SAVE_TEMPLATE = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__SAVE_TEMPLATE",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__ASSIGN_PLAN = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__ASSIGN_PLAN",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__SELECT_NEW_SLOT_MODAL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__SELECT_NEW_SLOT_MODAL",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__THEME_EDIT_MODAL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__THEME_EDIT_MODAL",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__THEME_EDIT__ADD_FOOD_GROUP = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__THEME_EDIT__ADD_FOOD_GROUP",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__DELETE_MEAL_DOUBLE_CONFIRM_MODAL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__DELETE_MEAL_DOUBLE_CONFIRM_MODAL",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__REPORT_VALIDATION_MODAL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__REPORT_VALIDATION_MODAL",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__ADD_NEW_MEAL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__ADD_NEW_MEAL",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__DELETE_MEAL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__DELETE_MEAL",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__COMPARE_MEALS = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__COMPARE_MEALS",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__COMPARE_MEALS__SELECT_MEAL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__COMPARE_MEALS__SELECT_MEAL",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__SELECT_MEAL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__SELECT_MEAL",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__SELECT_DISH = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__SELECT_DISH",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__RUN_AI = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__RUN_AI",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__EDIT_MEAL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__EDIT_MEAL",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__EDIT_MEAL_DELETE_MEAL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__EDIT_MEAL_DELETE_MEAL",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__EDIT_MEAL_CANCEL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__EDIT_MEAL_CANCEL",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__EDIT_MEAL_SAVE = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__EDIT_MEAL_SAVE",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__ADD_MEAL_TIP = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__ADD_MEAL_TIP",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__DELETE_MEAL_TIP = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__DELETE_MEAL_TIP",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__CUSTOM_ITEM_LOG_MODAL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__CUSTOM_ITEM_LOG_MODAL",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__CUSTOM_ITEM_LOG_MODAL__LOOK_UP_ON_WEB = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__CUSTOM_ITEM_LOG_MODAL__LOOK_UP_ON_WEB",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__PLAN_NAME = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__PLAN_NAME",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__PLAN_CALORIES = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__PLAN_CALORIES",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__PLAN_MACRO = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__PLAN_MACRO",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__SLOT_REMINDER_SELECT = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__SLOT_REMINDER_SELECT",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__PRO_TIP = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__PRO_TIP",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__MEAL_MORE_OPTION_SELECT = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__MEAL_MORE_OPTION_SELECT",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__DISH_MORE_OPTION_SELECT = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__DISH_MORE_OPTION_SELECT",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__COPY_MEALS_OPEN = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__COPY_MEALS_OPEN",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__COPY_MEALS_CANCEL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__COPY_MEALS_CANCEL",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__COPY_MEALS_SELECT = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__COPY_MEALS_SELECT",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__COPY_MEALS__SELECT_ALL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__COPY_MEALS__SELECT_ALL",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__COPY_MEALS__CLEAR_ALL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__COPY_MEALS__CLEAR_ALL",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__COPY_MEALS__SUBMIT = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__COPY_MEALS__SUBMIT",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__MEAL_PLATE_CONCEPT = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__MEAL_PLATE_CONCEPT",
	CREATE_PLAN_TAB__DIET_PLAN_EDIT__CONFIMRATION_MODAL = "CREATE_PLAN_TAB__DIET_PLAN_EDIT__CONFIMRATION_MODAL",
	REPORTS__TAB = "REPORTS__TAB",
	RCA__ACTION_ITEM = "RCA__ACTION_ITEM",
	RCA__PATIENT_SEARCH = "RCA__PATIENT_SEARCH",
	RCA__PATIENT_SELECT = "RCA__PATIENT_SELECT",
	RCA__PATIENT_LIST__TABLE_HEADER = "RCA__PATIENT_LIST__TABLE_HEADER",
	RCA__EDIT__CANCEL_CLICK = "RCA__EDIT__CANCEL_CLICK",
	RCA__EDIT__VIEW_PATIENT_HISTORY = "RCA__EDIT__VIEW_PATIENT_HISTORY",
	RCA__EDIT__PATIENT_PROFILE_REDIRECT = "RCA__EDIT__PATIENT_PROFILE_REDIRECT",
	RCA__EDIT__QUESTION_EXPAND = "RCA__EDIT__QUESTION_EXPAND",
	RCA__EDIT__QUESTION_COLLAPSE = "RCA__EDIT__QUESTION_COLLAPSE",
	RCA__EDIT__ADD_NEW_ACTION_ITEM_OPEN = "RCA__EDIT__ADD_NEW_ACTION_ITEM_OPEN",
	RCA__EDIT__ADD_NEW_ACTION_ITEM_SUBMIT = "RCA__EDIT__ADD_NEW_ACTION_ITEM_SUBMIT",
	RCA__EDIT__FOLLOW_UP_MODAL = "RCA__EDIT__FOLLOW_UP_MODAL",
	RCA__EDIT__FOLLOW_UP_MODAL_DATE_CHANGE = "RCA__EDIT__FOLLOW_UP_MODAL_DATE_CHANGE",
	WORKING_HOURS = "WORKING_HOURS",
	REQUESTS__APPLY_LEAVE = "REQUESTS__APPLY_LEAVE",
	REQUESTS__APPROVE_REQUEST = "REQUESTS__APPROVE_REQUEST",
	REQUESTS__REJECT_REQUEST = "REQUESTS__REJECT_REQUEST",
	CHAT__WINDOW__OPEN = "CHAT__WINDOW__OPEN",
	CHAT__WINDOW__CLOSE = "CHAT__WINDOW__CLOSE",
	CHAT__WINDOW__OPEN_FULLSCREEN = "CHAT__WINDOW__OPEN_FULLSCREEN",
	CHAT__WINDOW__OPEN_PATIENT_PROFILE = "CHAT__WINDOW__OPEN_PATIENT_PROFILE",
	CHAT__SIDEBAR__OPEN = "CHAT__SIDEBAR__OPEN",
	CHAT__SIDEBAR__CLOSE = "CHAT__SIDEBAR__CLOSE",
	CHAT__SIDEBAR__GROUP_CHAT = "CHAT__SIDEBAR__GROUP_CHAT",
	CHAT__SIDEBAR__INDIVIDUAL_CHAT = "CHAT__SIDEBAR__INDIVIDUAL_CHAT",
	CHAT__FULLSCREEN__GROUP_CHAT = "CHAT__FULLSCREEN__GROUP_CHAT",
	CHAT__FULLSCREEN__INDIVIDUAL_CHAT = "CHAT__FULLSCREEN__INDIVIDUAL_CHAT",
	CHAT__WINDOW__FULLSCREEN = "CHAT__WINDOW__FULLSCREEN",
	CHAT__SIDEBAR__FULLSCREEN = "CHAT__SIDEBAR__FULLSCREEN",
	CHAT__FULLSCREEN__EXIT_FULL_SCREEN = "CHAT__FULLSCREEN__EXIT_FULL_SCREEN",
	PATIENT_PROFILE__TICKET_DETAILS = "PATIENT_PROFILE__TICKET_DETAILS",
	CONSULTATION__HEADER_TAB_SELECT = "CONSULTATION__HEADER_TAB_SELECT",
	PATIENT_DATA__TAB_SELECT = "PATIENT_DATA__TAB_SELECT",
	ADD_NEW_METRICS_MODAL = "ADD_NEW_METRICS_MODAL",
	AUTOMATED_WORKING_HOURS = "AUTOMATED_WORKING_HOURS",
	DAILY_ACTIVITES__TAB__FOOD_TAB__TOP_CONTRIBUTORS_MODAL = "DAILY_ACTIVITES__TAB__FOOD_TAB__TOP_CONTRIBUTORS_MODAL",
	LINKS_LIBRARY = "LINKS_LIBRARY",
	PENDING_AUDIO_CHUCKS = "PENDING_AUDIO_CHUCKS",
	COACH_SCRIPT_INSTRUCTIONS_LINK_CLICK = "COACH_SCRIPT_INSTRUCTIONS_LINK_CLICK",
	PRESCRITPION_ACTIVE_FOODS_PRODUCT_DELETE = "PRESCRITPION_ACTIVE_FOODS_PRODUCT_DELETE",
	DEFAULT_PRESCRITPION_ACTIVE_FOODS_PRODUCT_ADDED = "DEFAULT_PRESCRITPION_ACTIVE_FOODS_PRODUCT_ADDED",
}

export const EVENT_NAMES = {
	COACH_CONSULT_TAB: {
		TAB_VISIT: "TAB_VISIT",
	},
	VOIP_CALL: {
		VOIP_CALL_BUTTON_CLICK: "VOIP_CALL_BUTTON_CLICK",
		COACH_MICROPHONE_BUTTON_CLICK: "COACH_MICROPHONE_BUTTON_CLICK",
		END_CALL_BUTTON_CLICK: "END_CALL_BUTTON_CLICK",
		REDIAL_BUTTON_CLICK: "REDIAL_BUTTON_CLICK",
		MINIMISE_VOIP_WIDGET_BUTTON_CLICK: "MINIMISE_VOIP_WIDGET_BUTTON_CLICK",
		VOIP_DEBUG_EVENT: "VOIP_DEBUG_EVENT",
		AUTO_END_DUE_TO_NO_ANSWER: "AUTO_END_DUE_TO_NO_ANSWER",
	},
	BCA_DATA: {
		DATE_RANGE_CHANGE: "DATE_RANGE_CHANGE",
	},
	ONGOING_CONSULT_VIDEO_TILE: {
		TOGGLE_AUDIO: "TOGGLE_AUDIO",
		TOGGLE_VIDEO: "TOGGLE_VIDEO",
		TOGGLE_SCREEN_SHARE: "TOGGLE_SCREEN_SHARE",
		REJOIN_CALL: "REJOIN_CALL",
		LEAVE_ROOM: "LEAVE_ROOM",
		SELECT_BG_IMAGE: "SELECT_BG_IMAGE",
	},
	PATIENT_PROFILE: {
		PROTEIN_UPSELL: "PROTEIN_UPSELL",
		CGM_UPSELL: "CGM_UPSELL",
		RENEWAL_LINK_UNLOCK_CLICK: "RENEWAL_LINK_UNLOCK_CLICK",
		RENEWAL_LINK_SEND_CLICK: "RENEWAL_LINK_SEND_CLICK",
		USER_PREFERENCES: "USER_PREFERENCES",
	},
	DIET_PLAN: {
		PREVIOUS_PLAN: {
			EDIT_PLAN_CLICK: "EDIT_PLAN_CLICK",
			ASSIGN_PLAN_CLICK: "ASSIGN_PLAN_CLICK",
		},
	},
	PATIENT_CONSULTATIONS: {
		CONSULTATION_CARD: {
			REQUEST_TRANSCRIPTION: "PATIENT_CONSULTATIONS__CONSULTATION_CARD__REQUEST_TRANSCRIPTION",
		},
	},
	CGM_DATA: {
		ACTIVATE_DELIVERED_CGM: "CGM_DATA__ACTIVATE_DELIVERED_CGM",
		GENERATE_AI_INSIGHTS: "CGM_DATA__GENERATE_AI_INSIGHTS"
	},
	EDIT_VIEW_CARD__EDIT: "EDIT_VIEW_CARD__EDIT",
	EDIT_VIEW_CARD__CANCEL: "EDIT_VIEW_CARD__CANCEL",
	EDIT_VIEW_CARD__SAVE: "EDIT_VIEW_CARD__SAVE",
	DOCTOR_PRESCRIPTION_PAGE: {
		ADVICES:{
			SELECT_ADVICES_BTN: "DOCTOR_PRESCRIPTION_PAGE__ADVICES__SELECT_ADVICES_BTN",
			ADD_CUSTOM_ADVICE_BTN: "DOCTOR_PRESCRIPTION_PAGE__ADVICES__ADD_CUSTOM_ADVICE_BTN",
		}
	},
	RING_USER: "RING_USER", 
}
